// extracted by mini-css-extract-plugin
var _1 = "ra-countdown";
var _2 = "ra-countdown-digit";
var _3 = "ra-countdown-label";
var _4 = "ra-countdown-section";
var _5 = "ra-countdown-separator";
var _6 = "ra-countdown-default";
var _7 = "ra-countdown-outlined";
export { _1 as "countdownCls", _2 as "countdownDigitCls", _3 as "countdownLabelCls", _4 as "countdownSectionCls", _5 as "countdownSeparatorCls", _6 as "countdownVariantDefaultCls", _7 as "countdownVariantOutlinedCls" }
